

export const addChangeTitleEventListener = (callback: (newTitle: string) => void): (() => void) => {
  const handleEvent = (e: CustomEvent<string>) => {
    callback(e.detail);
  }

  addEventListener(`CHANGE_TITLE_EVENT`, handleEvent);

  return () => removeEventListener(`CHANGE_TITLE_EVENT`, handleEvent);
}

export const changeTitle = (newTitle: string) => {
  dispatchEvent(new CustomEvent(`CHANGE_TITLE_EVENT`, {
    detail: newTitle,
  }));
}
